import jscAdd from 'ehogan-loader/jscmanager';

import CaptchaInput from 'source/lib/component/input/captcha';
import ErrorMessageBlock from 'source/lib/component/block/error_message';
import ExternalAuthButton from 'source/lib/component/button/external_auth';
import EulaInput from 'source/lib/component/input/eula';
import LoginInfoBlock from 'source/lib/component/block/login_info';
import LoginInput from 'source/lib/component/input/login';
import NameInput from 'source/lib/component/input/name';
import PasswordInput from 'source/lib/component/input/password';
import RememberInput from 'source/lib/component/input/remember';
import SubmitButton from 'source/lib/component/button/submit';
import TwoFactorInput from 'source/lib/component/input/twofactor';

jscAdd([
    CaptchaInput,
    ErrorMessageBlock,
    ExternalAuthButton,
    EulaInput,
    LoginInfoBlock,
    LoginInput,
    NameInput,
    PasswordInput,
    RememberInput,
    SubmitButton,
    TwoFactorInput
]);

export {
    CaptchaInput,
    ErrorMessageBlock,
    ExternalAuthButton,
    EulaInput,
    LoginInfoBlock,
    LoginInput,
    NameInput,
    PasswordInput,
    RememberInput,
    SubmitButton,
    TwoFactorInput
};



// WEBPACK FOOTER //
// ./static-source/js/lib/components.js